import {
  Box,
  Container,
  Divider,
  SelectChangeEvent,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Report from "./Report";
import reportStyles from "./Report.styles";
import resumeStyles from "./Report.styles";
import history from "../../../../utils/history";
import { theme } from "../../../../utils/styles";
import { useTranslation } from "react-i18next";
import backArrow from "../../../../assets/icons/backArrow.svg";
import CustomSelect from "../../../../global/components/CustomSelect/CustomSelect";
import { useEffect, useState } from "react";
import { formData, formValidation } from "../Football/FootballValidation";
import Data from "./Data";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import { isTruthy } from "../../../../helpers/methods";

const GenerateReportAdmin = () => {
  const classes = reportStyles;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  const [tableData, setTableData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [fileName, setFileName] = useState<string>("");

  const getHeader = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { sm: "center", xs: "baseline" },
          width: "100%",
        }}
        pb={3}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          sx={{ cursor: "pointer", width: "fit-content" }}
          onClick={() => history.goBack()}
        >
          {isMobile ? (
            <img src={backArrow} height={"20px"} alt="Module not found..." />
          ) : (
            <img src={backArrow} height={"25px"} alt="Module not found..." />
          )}
        </Box>
        <Typography sx={classes.italicTypo}>{t("personalData")}</Typography>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        ...classes.mainContainer,
        overflow: "scrollbar", // Prevent content from overflowing
        height: "100%", // Set a specific height
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          ...classes.mainBox,
          overflow: "scrollbar",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            ...classes.subBox,
            overflow: "scrollbar", // Allow scrolling within this container
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Container
            maxWidth="xl"
            sx={{
              px: 1,
              overflow: "hidden",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {getHeader()}
            <Report setTableData={setTableData} setFileName={setFileName} />
            {isTruthy(tableData) && (
              <>
                <Divider sx={{ marginY: 2, background: "white" }} />
                <Typography sx={classes.italicTypo}>{t("data")}</Typography>
                <Box
                  sx={{
                    height: "500px",
                    overflow: "auto", // Allow scrolling for the data table
                    border: "1px solid rgba(255,255,255,0.2)", // Optional: add border to see boundaries
                    borderRadius: 1,
                  }}
                >
                  <Data
                    setIsLoading={setIsLoading}
                    data={tableData}
                    fileName={fileName}
                  />
                </Box>
              </>
            )}
          </Container>
        </Box>
      </Box>
      <CustomLoader isLoading={isLoading} />
    </Box>
  );
};

export default GenerateReportAdmin;
